import { useQuery } from '@tanstack/react-query';

import PortainerError from '@/portainer/error';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { AuthTypeOption } from '../../account/git-credentials/types';

interface SearchPayload {
  repository: string;
  keyword: string;
  reference?: string;
  username?: string;
  password?: string;
  authorizationType?: AuthTypeOption;
  tlsSkipVerify?: boolean;
  dirOnly?: boolean;
  createdFromCustomTemplateId?: number;
  stackId?: number;
  fromEdgeStack?: boolean;
}

export function useSearch(payload: SearchPayload, enabled: boolean) {
  return useQuery<Awaited<ReturnType<typeof searchRepo>>, PortainerError>(
    ['git_repo_search_results', { payload }],
    () => searchRepo(payload),
    {
      enabled,
      retry: false,
      cacheTime: 0,
    }
  );
}

export async function searchRepo(payload: SearchPayload) {
  try {
    const { data } = await axios.post<string[] | null>(
      '/gitops/repo/files/search',
      payload
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error as Error);
  }
}
